import type { UnmatchedUidRow } from 'api/canonicalPicker.types'

// The most pasted uids one paste checks
export const MAX_PASTED_UIDS = 100

// Commas, semicolons, whitespace and line breaks
const SEPARATORS = /[\s,;]+/

// The uid shapes in the catalog: digits (Olo, Brink, NCR, Omnivore, Qu,
// Genius, Toast globals), GUIDs (Toast, Deliverect), 24 lowercase hex digits
// (Deliverect) and 24 capitals and digits (Square)
const GUID = /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i
const UID_SHAPES = [/^\d{1,20}$/, GUID, /^[\da-f]{24}$/, /^[\dA-Z]{24}$/]

/** Whether a search term has the shape of a catalog UID rather than a name */
export const looksLikeUid = (token: string): boolean =>
  UID_SHAPES.some(shape => shape.test(token))

// The catalog holds GUIDs in lowercase, however they were typed or pasted
export const asInCatalog = (token: string): string =>
  GUID.test(token) ? token.toLowerCase() : token

/**
 * The distinct uids in pasted text, or null when any part of it reads as
 * something else, like a name, so the paste stays a name search.
 */
export const uidsInPaste = (text: string): string[] | null => {
  const tokens = text.split(SEPARATORS).filter(Boolean)
  if (tokens.length === 0 || !tokens.every(looksLikeUid)) return null
  return Array.from(new Set(tokens.map(asInCatalog)))
}

/** A pasted uid the merchant adds though nothing matches it */
export const unmatchedUidRowOf = (uid: string): UnmatchedUidRow => ({
  kind: 'unmatchedUid',
  id: `unmatched:${uid}`,
  uid,
  name: uid,
})
